import {DefaultTheme, useTheme as useDefaultTheme} from 'styled-components';

export const useTheme = (): DefaultTheme => {
  const theme = useDefaultTheme();

  return theme;
};
